import React from 'react';
import UnifiedResetPassword from '@components/UnifiedResetPassword';

const ResetPassword: React.FC = () => {
  return <UnifiedResetPassword theme="light" />;
};

export default ResetPassword;
